import a from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function l(r) {
  o(1, arguments);
  var t = a(r), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(t.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
export {
  l as default
};
